var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._t("name")],2),_c('v-spacer'),_vm._t("preferences")],2)}
var staticRenderFns = []

export { render, staticRenderFns }